<script lang="ts" setup>
import { useRouter } from "vue-router";
import PanelGrid from "@/views/shared/components/PanelGrid.vue";
import PanelCard from "@/views/shared/components/PanelCard.vue";
import PageHeader from "@/components/PageHeader.vue";
import ScheduleList from "./components/ScheduleList.vue";

// Root Scheduler page: the full, global list (all projects) with stats, filters and bulk actions.
// Editing/creating navigates to the dedicated route pages.
const router = useRouter();

function editSchedule(scheduleId: string) {
  router.push(`/scheduler/edit/${scheduleId}`);
}
function createSchedule() {
  router.push("/scheduler/new");
}
</script>

<template>
  <main>
    <PanelGrid :columns="1">
      <PanelCard>
        <div class="d-flex flex-column gap-4">
          <PageHeader
            title="Scheduled Workflows"
            :breadcrumbs="[{ label: 'Dashboard', href: '/' }, { label: 'Scheduler' }]"
          >
            <template #actions>
              <button class="bb-btn-primary-cta" @click="createSchedule">
                <i class="bi bi-plus me-2"></i>New<span class="d-none d-md-inline"> Schedule</span>
              </button>
            </template>
          </PageHeader>

          <ScheduleList
            :show-stats="true"
            :show-filters="true"
            :show-bulk="true"
            @edit="editSchedule"
            @create="createSchedule"
          />
        </div>
      </PanelCard>
    </PanelGrid>
  </main>
</template>
